import { watch, type Ref } from 'vue';
import { useDocumentVisibility } from '@vueuse/core';
import { POLLING_INTERVAL_VISIBLE } from '@/constants';

type PollingQuery = {
  startPolling: (interval: number) => void;
  stopPolling: () => void;
};

// Control Apollo's timer directly: changing query options restarts the query.
export function useVisibleQueryPolling(
  query: Ref<PollingQuery | null | undefined>
) {
  const visibility = useDocumentVisibility();
  watch(
    [visibility, query],
    ([state, current]) => {
      if (state === 'visible') current?.startPolling(POLLING_INTERVAL_VISIBLE);
      else current?.stopPolling();
    },
    { immediate: true, flush: 'sync' }
  );
}
